<template>
  <main
    :class="`home-page fade-in-fwd ${
      isMenuOpen ? 'isMenuOpenPadding' : 'isMenuClosePadding'
    }`"
  >
    <div
      class="d-flex justify-content-end align-items-center refreshbutton"
    ></div>
    <div class="w-full flex flex-col gap-4 py-4 md:py-4 md:px-4">
      <!-- Last Roulette Numbers Component -->

      <!-- Live Players Component -->
      <div
        id="room-players"
        class="w-full shadow-xl rounded-2xl overflow-hidden border border-slate-200 bg-white"
      >
        <RoomPlayers />
      </div>

      <LastRouletteNumber />
    </div>
  </main>
</template>

<script setup>
import { computed } from "vue";
import { useStore } from "vuex";
import RoomPlayers from "@/slot/components/charts/RoomPlayers.vue";
import LastRouletteNumber from "../components/lastRouletteNumber.vue";

const store = useStore();
const isMenuOpen = computed(() => store.state.isMenuOpen);
</script>

<style scoped></style>
